module.exports = __webpack_public_path__ + "static/media/van_blue.be95feae.svg";